import axios from "axios";

const generarBarcodeProductoService = async (id) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
        responseType: 'blob',
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/barcode/${id}`,
            config
        );

        const blob = response.data;

        // Crear un enlace temporal
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `barcode_${id}.png`;
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);

        return [true];
    } catch (error) {
        return [false, error.response?.status, error.response?.data];
    }
};


export {
    generarBarcodeProductoService
}